export const DocumentTypeData = [
    {
    id: 1,
    docCode: "DOC-001",
    docName: "Identity Proof",
    description:
      "Documents that verify the identity of the individual, such as National ID, Passport, or Driving License.",
    requiredFor: "All Users",
    createdBy: "System Admin",
    createdDate: "2023-06-10",
    status: "Active",
  },
  {
    id: 2,
    docCode: "DOC-002",
    docName: "Transaction Receipt",
    description:
      "Proof of transaction provided by the customer or system to validate payment-related disputes.",
    requiredFor: "Dispute Resolution",
    createdBy: "Finance Department",
    createdDate: "2023-07-15",
    status: "Active",
  },
  {
    id: 3,
    docCode: "DOC-003",
    docName: "Account Statement",
    description:
      "Official bank or digital wallet statement to verify debits, credits, and disputed amounts.",
    requiredFor: "Finance Verification",
    createdBy: "Audit Team",
    createdDate: "2023-08-01",
    status: "Active",
  },
  {
    id: 4,
    docCode: "DOC-004",
    docName: "Proof of Purchase",
    description:
      "Invoice, order receipt, or bill that confirms a purchase for refund or return-related disputes.",
    requiredFor: "Merchant Disputes",
    createdBy: "Customer Support",
    createdDate: "2023-08-20",
    status: "Inactive",
  },
  {
    id: 5,
    docCode: "DOC-005",
    docName: "Authorization Letter",
    description:
      "Document authorizing a representative to raise or resolve disputes on behalf of a customer.",
    requiredFor: "Corporate Accounts",
    createdBy: "Legal Department",
    createdDate: "2023-09-12",
    status: "Active",
  },
  {
    id: 6,
    docCode: "DOC-006",
    docName: "Merchant Agreement",
    description:
      "Contract between the merchant and the organization outlining terms of service and dispute handling.",
    requiredFor: "Merchant Registration",
    createdBy: "Operations Team",
    createdDate: "2023-10-05",
    status: "Active",
  },
  {
    id: 7,
    docCode: "DOC-007",
    docName: "Fraud Investigation Report",
    description:
      "Detailed report generated after a fraud analysis, used to finalize dispute resolution outcomes.",
    requiredFor: "Fraud Cases",
    createdBy: "Fraud Investigation Unit",
    createdDate: "2023-11-01",
    status: "Active",
  },
]